import get from "lodash.get";
import styled from "styled-components";

export const SubExpiredModalStyle = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 999999;
  .content {
    background-color: ${({ theme }) => get(theme, "background.main")};
    max-width: 500px;
    height: auto;
    padding: 16px;
    border-radius: 10px;
    a {
      text-decoration: none;
    }
  }
`;
